import axios from 'axios';
import {getBuildNumber,getVersion} from 'react-native-device-info';
import { isNetworkAvailable } from '../../hooks/useConnection';
import { useAppPersistenceStore } from '../../store/useAppPersistenceStore';
import { useProfileStore } from '../../store/useProfileStore';
import { getFeedExchangeTokenSync } from '../kisaan/commonApi';
import { getFeedURI } from '../paths';
import { Platform } from 'react-native';
import {webBuildNumber} from "@ninjacart/nc-nk-core";

export const FeedClient = axios.create({
  baseURL: getFeedURI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    Authorization: `Bearer ${useProfileStore.getState().feedConfig}`,
    'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
     ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

FeedClient.interceptors.request.use(async (config) => {
  // await syncStreamChannels();
  const isConnected = isNetworkAvailable();
  if (!isConnected) {
    console.log('Network in not connected!!!');
    return Promise.reject('No internet available!!!');
  }

  config.headers.Authorization = `Bearer ${useProfileStore.getState().feedConfig}`;
  config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage;

  // FeedClient.interceptors.request.eject(interceptor);
  return Promise.resolve(config);
});

FeedClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      (error?.response?.status === 401 || !useProfileStore.getState()?.feedConfig) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const userId = useProfileStore.getState()?.userProfile?.user?.id ?? null;
        if (!userId) {
          // throw new Error('Without user id exchange token api cannot be invokable');
          console.log('No user id present!!!');
          return;
        }

        const mastodonToken = await getFeedExchangeTokenSync(userId);

        console.log('Access token new => ', mastodonToken);
        useProfileStore.getState()?.setFeedConfig(mastodonToken);

        // Retry the original request with the new token
        if (mastodonToken) {
          originalRequest.headers.Authorization = mastodonToken ? `Bearer ${mastodonToken}` : '';
        }

        originalRequest.headers['x-language-code'] =
          useAppPersistenceStore?.getState()?.appLanguage;
        return axios(originalRequest);
      } catch (error) {
        // Handle refresh token error or redirect to login
        console.error('Unable to get peertube access token on expiry.', error);
      }
    }

    // const config = error.config;
    //  return handleRetry(error, config, 'STREAM_CLIENT_API_FAILED', FeedClient);
    return Promise.reject(error);
  }
);
